// extracted by mini-css-extract-plugin
export var bigText = "TopBar-module--big-text--88311";
export var layout = "TopBar-module--layout--f1920";
export var richText = "TopBar-module--rich-text--dd61b";
export var text = "TopBar-module--text--fa48a";
export var topBar = "TopBar-module--top-bar--8ba59";